module.exports = __webpack_public_path__ + "img/wall.f47f3932.png";